const flutterPassengers = {
  en: {
    flutterPassengers: {
      title: 'Passengers',
      description: 'Accident, Damage, Stealing',
      instructions: 'Instructions',
      'instructions.description': 'Procedure for obtaining insurance aid',
      'instructions.kz': 'Phone calls within Kazakhstan is free of charge',
      'instructions.world': 'For International Calls',
      'instructions.whatsapp': 'Write to WhatsApp',
      'instructions.title': 'Compulsory civil liability insurance',
      'acc1.title': 'Client Actions',
      'acc1.text1':
        '1. Please take measures that are reasonable under the current circumstances in order to mitigate possible losses and provide assistance to the injured persons;',
      'acc1.text2':
        '2. Please notify the relevant authorities of the insured event and the injured persons (police officers, fire-fighting services, ambulance service, emergency services);',
      'acc1.text3':
        '3. Please notify the Insurance Company immediately, but no later than within three working days after the insured event.',
      'acc1.text4': '4. Please draw up a Vehicle Accident Report;',
      'acc1.text5':
        '5. Please provide the Insurance Company with the assignment of its right of recourse to the person responsible for the insured event.',
      'acc2.title': 'List of documents:',
      'acc2.text1':
        'The following documents shall be attached to the application for the insurance benefit:',
      'acc2.text2':
        '1. A document confirming the fact of the insured event and the extent of damage caused to the injured party; ',
      'acc2.text3':
        '2. A statement of an insured event in transport prepared by the carrier; ',
      'acc2.text4':
        '3. Travel ticket or a document replacing it (copy of the ticket sale statement or ticket stub certified by the carrier) - in case the passenger has been issued a ticket, or testimonial evidence drawn up in accordance with the procedure established by the legislation of the Republic of Kazakhstan;',
      'acc2.text5':
        '4. A copy of a certificate from health care organizations confirming the period of temporary disability or a certificate from specialized institutions confirming the establishment of disability for the victim - if stipulated;',
      'acc2.text6':
        "5. A notarized copy of the victim's death certificate and a document confirming the beneficiary's right to compensation for damages in case of the victim's death (copy);",
      'acc2.text7':
        '6. List of lost, missing or damaged property of the injured party - in case of damage to the property;',
      'acc2.text8':
        '7. Documents confirming expenses incurred by the insured to prevent or reduce losses upon occurrence of the insured event - if any available.',
      'acc2.text9':
        '02-1. The transport accident report drawn up by the carrier should contain the following information:',
      'acc2.text10':
        '1. Surname, first name, patronymic of the injured person;',
      'acc2.text11': '2. Type of transport;',
      'acc2.text12': "3. Trip number, train number, ship's name, etc.;",
      'acc2.text13': '4. The route of the trip;',
      'acc2.text14':
        '5. The series and number of the travel ticket available at the victim;',
      'acc2.text15':
        '6. Place, date and time of occurrence of the insured event;',
      'acc2.text16':
        '7. Description of the injuries caused to the life and health of the injured party;',
      'acc2.text17':
        '8. Characteristic of the damages caused to the property of the injured party; ',
      'acc2.text18':
        '9. A brief description of the circumstances of the insured event; ',
      'acc2.text19': '10. Name of the competent investigating authority; ',
      'acc2.text20':
        '11. Name and location of the medical institution where the injured person has been referred to;',
      'acc2.text21':
        '12. Name, surname and signature of the head of the transport organization or the transport means;',
      'acc2.text22':
        '13. Name, surname, patronymic and signature of the representative of the competent authority conducting the investigation;',
    },
  },
  kz: {
    flutterPassengers: {
      title: 'Жолаушылар',
      description: 'Апат, Зақымдану, Айдап әкету',
      instructions: 'Нұсқаулықтар',
      'instructions.description':
        'Сіздің сақтандыру көмегін алу үшін  әрекет ету тәртібіңіз',
      'instructions.kz': 'Қазақстан бойынша қоңырау шалу тегін',
      'instructions.whatsapp': 'WhatsApp-ға жазу',
      'instructions.title': 'ЖТ МАҚМ',
      'acc1.title': 'Клиенттің әрекеттері',
      'acc1.text1':
        '1. Ықтимал шығындарды азайту және зардап шеккен адамдарға көмек көрсету үшін қазіргі жағдайда ақылға қонымды шаралар қолданыңыз;',
      'acc1.text2':
        '2. Тиісті органдарға сақтандыру жағдайы және зардап шеккен адамдар туралы хабарлаңыз (полиция қызметкерлеріне, өртке қарсы қызметке, жедел медициналық жәрдем қызметіне, авариялық қызметтерге);',
      'acc1.text3':
        '3. Сақтандыру жағдайы басталғаннан кейін шұғыл түрде, алайда үш жұмыс күнінен кешіктірмей сақтандыру компаниясына хабарлаңыз.',
      'acc1.text4': '4. Көліктегі сақтандыру жағдайы туралы акт жасаңыз;',
      'acc1.text5':
        '5. Сақтандыру компаниясына сақтандыру жағдайының басталуына жауапты адамға кері талап ету құқығының ауысуын беріңіз.',
      'acc2.title': 'Құжаттар тізімі',
      'acc2.text1':
        'Сақтандыру төлемі туралы өтінішке мынадай құжаттар қоса беріледі:',
      'acc2.text2':
        '1. Сақтандыру жағдайының басталу фактісін және жәбірленушіге келтірілген зиянның мөлшерін растайтын құжат;',
      'acc2.text3':
        '2. Тасымалдаушы жасаған көліктегі сақтандыру жағдайы туралы акті;',
      'acc2.text4':
        '3. Жол жүру билеті немесе оны алмастыратын құжат (билеттерді сату ведомосінің немесе тасымалдаушы куәландырған билет түбіртегінің көшірмесі) - жолаушыға билет берілген жағдайда немесе Қазақстан Республикасының заңнамасында белгіленген тәртіппен ресімделген куәлік айғақтары;',
      'acc2.text5':
        '4. Еңбекке уақытша жарамсыздық мерзімі туралы денсаулық сақтау ұйымдарының анықтамасының немесе жәбірленушінің мүгедектігін белгілеу туралы мамандандырылған мекемелердің анықтамасының көшірмесі-ол анықталған жағдайда;',
      'acc2.text6':
        '5. Жәбірленушінің қайтыс болуы туралы куәліктің нотариат куәландырған көшірмесі және пайда алушының жәбірленуші қайтыс болған жағдайда зиянды өтету құқығын растайтын құжат (көшірме);',
      'acc2.text7':
        '6. Жәбірленушінің жоғалған, жетіспейтін немесе бүлінген мүлкінің тізбесі - мүлікке зиян келтірілген жағдайда;',
      'acc2.text8':
        '7. Сақтандыру жағдайы басталған кезде шығындарды болдырмау немесе азайту мақсатында сақтандырылушының шеккен шығындарын растайтын құжаттар-олар болған кезде.',
      'acc2.text9':
        '02-1. Тасымалдаушы жасаған көліктегі сақтандыру жағдайы туралы актіде мынадай мәліметтер болуға тиіс:',
      'acc2.text10': '1. жәбірленушінің тегі, аты, әкесінің аты;',
      'acc2.text11': '2. көлік түрі;',
      'acc2.text12': '3. рейс нөмірі, пойыз нөмірі, кеме атауы және т.б.;',
      'acc2.text13': '4. жүру бағыты;',
      'acc2.text14':
        '5. жәбірленушідегі жол жүру билетінің сериясы мен нөмірі;',
      'acc2.text15': '6. сақтандыру жағдайының басталу орны, күні және уақыты;',
      'acc2.text16':
        '7. жәбірленушінің өмірі мен денсаулығына келтірілген зиянның сипаттамасы;',
      'acc2.text17':
        '8. жәбірленушінің мүлкіне келтірілген зиянның сипаттамасы;',
      'acc2.text18':
        '9. сақтандыру жағдайының жағдайларының қысқаша сипаттамасы;',
      'acc2.text19':
        '10. тергеп-тексеруді жүзеге асыратын құзыретті органның атауы;',
      'acc2.text20':
        '11. жәбірленуші жіберілген медициналық мекеменің атауы және орналасқан жері;',
      'acc2.text21':
        '12. көлік ұйымы немесе көлік құралы басшысының тегі, аты, әкесінің аты және қолы;',
      'acc2.text22':
        '13. тексеруді жүзеге асыратын құзыретті орган өкілінің тегі, аты, әкесінің аты және қолы;',
    },
  },
  ru: {
    flutterPassengers: {
      title: 'Пассажиры',
      description: 'Авария, Повреждение, Угон',
      instructions: 'Инструкции',
      'instructions.description':
        'Ваш порядок действий для получения страховой помощи',
      'instructions.kz': 'Звонок по Казахстану бесплатный',
      'instructions.whatsapp': 'Написать в WhatsApp',
      'instructions.title': 'ОГПО ПП',
      'acc1.title': 'Действия клиента',
      'acc1.text1':
        '1. Примите разумные в сложившихся обстоятельствах меры, чтобы уменьшить возможные убытки и окажите помощь пострадавшим лицам;',
      'acc1.text2':
        '2. Сообщите в соответствующие органы о страховом случае и пострадавших лицах (сотрудникам полиции, в противопожарную службу, в службу скорой медицинской помощи, аварийные службы);',
      'acc1.text3':
        '3. Незамедлительно, но не позднее трех рабочих дней, после наступления страхового случая, уведомите Страховую компанию.',
      'acc1.text4': '4. Составьте акт о страховом случае на транспорте;',
      'acc1.text5':
        '5. Предоставьте Страховой компании переход своего права обратного требования к лицу, ответственному за наступление страхового случая.',
      'acc2.title': 'Список документов',
      'acc2.text1':
        'К заявлению о страховой выплате прилагаются следующие документы:',
      'acc2.text2':
        '1. Документ, подтверждающий факт наступления страхового случая и размер вреда, причиненного потерпевшим; ',
      'acc2.text3':
        '2. Акт о страховом случае на транспорте, составленный перевозчиком; ',
      'acc2.text4':
        '3. Проездной билет или документ, заменяющий его (копия ведомости продажи билетов или корешка билета, заверенная перевозчиком), - в случае выдачи пассажиру билета, или свидетельские показания, оформленные в порядке, установленном законодательством Республики Казахстан;',
      'acc2.text5':
        '4. Копия справки организаций здравоохранения о сроке временной нетрудоспособности или справки специализированных учреждений об установлении инвалидности потерпевшему - в случае ее установления;',
      'acc2.text6':
        '5. Нотариально удостоверенная копия свидетельства о смерти потерпевшего и документ, подтверждающий право выгодоприобретателя на возмещение вреда в случае смерти потерпевшего (копия);',
      'acc2.text7':
        '6. Перечень утраченного, недостающего или поврежденного имущества потерпевшего - в случае нанесения вреда имуществу;',
      'acc2.text8':
        '7. Документы, подтверждающие расходы, понесенные застрахованным в целях предотвращения или уменьшения убытков при наступлении страхового случая, - при их наличии.',
      'acc2.text9':
        '02-1. Акт о страховом случае на транспорте, составленный перевозчиком, должен содержать следующие сведения:',
      'acc2.text10': '1. фамилия, имя, отчество потерпевшего;',
      'acc2.text11': '2. вид транспорта;',
      'acc2.text12': '3. номер рейса, номер поезда, название судна и т. п.;',
      'acc2.text13': '4. маршрут следования;',
      'acc2.text14':
        '5. серия и номер проездного билета, имеющегося у потерпевшего;',
      'acc2.text15': '6. место, дата и время наступления страхового случая; ',
      'acc2.text16':
        '7. характеристика повреждений, причиненных жизни и здоровью потерпевшего;',
      'acc2.text17':
        '8. характеристика повреждений, причиненных имуществу потерпевшего;',
      'acc2.text18': '9. краткое описание обстоятельств страхового случая;',
      'acc2.text19':
        '10. наименование компетентного органа, осуществляющего расследование;',
      'acc2.text20':
        '11. наименование и местонахождение медицинского учреждения, куда был направлен потерпевший;',
      'acc2.text21':
        '12. фамилия, имя, отчество и подпись руководителя транспортной организации либо транспортного средства; ',
      'acc2.text22':
        '13. фамилия, имя, отчество и подпись представителя компетентного органа, осуществляющего расследование;',
    },
  },
};

export default flutterPassengers;
